/**
 * 远程桌面连接 reducer
 */
import { combineReducers } from 'redux';
import * as ACTIONS from '../actions/operationAudit_action';

function operationAuditData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_OPERATION_AUDIT_DATA:
            return action.operationAuditData
        default:
            return state
    }
}

const operationAuditReducer = combineReducers({
    operationAuditData,
})

export default operationAuditReducer;
